import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';

@Injectable()
export class ExcelService {

  constructor() { }
  public totalEfectivo = 0;
  public totalTarjeta = 0;


/*MÉTODO PARA EXPORTAR EN EXCEL*/
        public dataListaExport = [];
        public headers:Array<any>[];

        public exportXlsTableView = function(data, columnas, filename) {
            this.totalEfectivo = 0;
            this.totalTarjeta = 0;
            this.dataListaExport = this.formatJSONData(columnas, data);
            this.drawTable(this.dataListaExport, filename, columnas.length - 1);
        };

        /*CREA UN NUEVO JSON EN BASE A LA INFORMACION DE colDef Y dataListaEventoOperador*/
        public formatJSONData = function(columns, data) {
            let i = 0;
            let lenght = 0;
            let str = "";
            this.headers = new Array<any>();
            let that = this;
            
            this.dataListaExport = [];
            columns.forEach(function(col) {
                let colString = "";
                //if (col.visible && col != 'sinDato' && col != 'Avance') {
                    let element = {field: "", name: ""};
                    element.field = col;
                    element.name = col;
                    that.headers.push(element);
                //}

                /*if (!col.visible && col == 'Avance de Ruta') {
                    let element:any;
                    element.field = col;
                    element.name = col;
                    this.headers.push(element);
                }*/
            });

            data.forEach(function(evento) {
                let reg = '{';
                let colIndex = 0;



                columns.forEach(function(col) {
                    if ((colIndex + 1) != columns.length) {
                        if (evento[col] != null && evento[col] != undefined) {
                            reg += "\"" + col + "\"" + ":" + "\"" + evento[col].toString().split('"').join('\'') + "\",";
                        } else {
                                reg += "\"" + col + "\"" + ":" + "\"" + "\",";
                        }
                    }
                    else {
                        if (evento[col] != null && evento[col] != undefined) {
                            reg += "\"" + col + "\"" + ":" + "\"" + evento[col].toString().split('"').join('\'') + "\"";
                        }
                        else {
                                reg += "\"" + col + "\"" + ":" + "\"" + "\"";
                        }
                    }
                    colIndex++;
                });

                if ((lenght + 1) != data.length && (lenght + 1) != 0) {
                    reg += "},";
                }
                else {
                    reg += "}";
                }
                str += reg;
                lenght++;
            });

            let jsonObj = $.parseJSON('[' + str + ']');
            return jsonObj;
        };

        /*CREA UN STRING QUE TENDRÁ EL FORMATO DE UNA TABLA HTML Y LUEGO LA CONVIERTE A TRAVÉS DEL PLUGIN*/
        public drawTable = function(data, filename, comvinar) {
            let table = '<style>.textoCambio{mso-number-format:"\@";}</style> <table id="DataTable" cellspacing="0" cellpadding="0"><tr>'

            /*AGREGA LOS ENCABEZADOS*/
            let headersString = "";
            this.headers.forEach(function(header) {
                let head = "";          

                if(comvinar == 6)
                {
                    switch(header.name){
                      case "NAME":{
                        head = "Nombre del personal";
                        break;
                      }
                      case "formaPago":{
                        head = "Forma de pago";
                        break;
                      }
                      case "subtotal":{
                        head = "Subtotal";
                        break;
                      }
                      case "imss":{
                        head = "IMSS";
                        break;
                      }
                      case "infonavit":{
                        head = "INFONAVIT";
                        break;
                      }
                      case "total":{
                        head = "Total";
                        break;
                      }
                    }
                }
                else{
                    switch(header.name){
                      case "NAME":{
                        head = "Nombre del personal";
                        break;
                      }
                      case "formaPago":{
                        head = "Forma de pago";
                        break;
                      }
                      case "anticipo":{
                        head = "Anticipo";
                        break;
                      }
                    }
                }
                headersString += '<th style="text-align: center;font-size:16px;"><b>' + head + '</b></th>';
            });

            table += headersString + "</tr>";

            /*AGREGA LOS REGISTROS*/
            let index = 0;
            let that = this;
            data.forEach(function(row) {
                let dataRow = that.drawRow(index, row, comvinar);
                table += dataRow;
            });

            table += '<tr><td colspan="'+ ((comvinar != 6) ? 2 : comvinar - 1) +'" style="text-align: right;font-size:15px;"><b>Total en Efectivo</b></td><td class="textoCambio">$'+ parseFloat(this.totalEfectivo).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") +'</td></tr>';
            table += '<tr><td colspan="'+ ((comvinar != 6) ? 2 : comvinar - 1) +'" style="text-align: right;font-size:15px;"><b>Total en Depósito</b></td><td class="textoCambio">$'+ parseFloat(this.totalTarjeta).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") +'</td></tr>';
            table += '<tr><td></td></tr>';
            table += '<tr><td colspan="'+ ((comvinar != 6) ? 2 : comvinar - 1) +'" style="text-align: right;font-size:15px;"><b>Gran Total</b></td><td class="textoCambio">$'+ parseFloat((this.totalTarjeta + this.totalEfectivo)).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") +'</td></tr>';  

            table += "</table>";
            document.getElementById("excelTable").innerHTML = table;

            let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            //let isFirefox = typeof InstallTrigger !== 'undefined';

            if (isSafari) {
                let blob = new Blob([table], { type: "application/vnd.ms-excel" });
                FileSaver.saveAs(blob, filename+'.xls');
            } else {
                let blob = new Blob([table], { type: "text/plain;charset=utf-8" });
                FileSaver.saveAs(blob, filename+'.xls');
            }
        };

        /*CREA UNA FILA EN LA TABLA EN BASE A LA INFORMACIÓN CORRESPONDIENTE AL json-dataEventoOperadorRow[i]*/
        public drawRow = function(i, dataRow, comvinar) {
            let value;
            let row = "<tr>";
            let that = this;
            if ((i % 2) == 0) {
                this.headers.forEach(function(elem) {
                  if(elem.name != "ordenar"){
                    if (dataRow[elem.name] == undefined) {
                        value = ''
                    }
                    else {
                        value = dataRow[elem.name]
                    }
                    if(comvinar == 6)
                    {
                      if(elem.name == "total" && value != "")
                      {
                        if(dataRow["formaPago"] == "EFECTIVO")
                        {
                          that.totalEfectivo += parseFloat(value);
                        }
                        else{
                          that.totalTarjeta += parseFloat(value);
                        }
                      }
                    }
                    else{
                      if(elem.name == "anticipo" && value != "")
                      {
                        if(dataRow["formaPago"] == "EFECTIVO")
                        {
                          that.totalEfectivo += parseFloat(value);
                        }
                        else{
                          that.totalTarjeta += parseFloat(value);
                        }
                      }
                    }
                    
                    if(dataRow["total"] != ""){
                      if (elem.name != "NAME" && elem.name != "formaPago") {
                          if (comvinar != 6){
                              if(elem.name == "anticipo")
                              {
                                  row += '<td class="textoCambio">$';
                                  if (parseFloat(value).toFixed(2).toString() != 'NaN') {
                                          row += parseFloat(value).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + '</td>';
                                  }
                                  else {
                                          row += parseFloat("0").toFixed(2) + '</td>';
                                  }
                              }
                          }
                          else{
                              row += '<td class="textoCambio">$';
                              if (parseFloat(value).toFixed(2).toString() != 'NaN') {
                                      row += parseFloat(value).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + '</td>';
                              }
                              else {
                                      row += parseFloat("0").toFixed(2) + '</td>';
                              }
                          }
                      }
                      else{
                          if(dataRow["ordenar"] == 1)
                          {
                            row += '<td style="color:red;">' + value + '</td>';
                          }
                          else
                            row += '<td>' + value + '</td>';
                        }
                    }
                    else{
                      if(elem.name == "NAME")
                      row += '<td colspan="'+ ((comvinar != 6) ? 3 : comvinar) +'" style="background-color: #929292;color:white;font-size:15px;"><b>' + value + '<b></td>';
                    }
                  }
                });
            } else {
                this.headers.forEach(function(elem) {
                    if (dataRow[elem.name] == undefined) {
                        value = '';
                    }
                    else {
                        value = dataRow[elem.name];
                    }
                    row += '<td style="background-color: #EBEAE8;"><b>' + value + '</b></td>';
                });
            }

            row += "</tr>";
            return row;
        };



}


// WEBPACK FOOTER //
// ./src/app/services/ExcelService.component.ts